const QuickAccessComponentConstants = {
    WIDTH_HEIGHT_IMG: "52px",
    SVG_HOVER: "Hover",
}

export default QuickAccessComponentConstants;